<div class="sticky-head">
    <div class="sticky-head-in">
        <div class="menu-bar">
            <i class="fas fa-bars disply" (click)="toggleLeftNav()"></i>
            <!-- <a class="logo-text">
                <div class="logo-img"><img src="../../assets/images/logo.png" alt="logo" /></div>
            </a> -->
            <ic-auto-complete *ngIf="showSearchBox" [autoCompleteItemList]="restaurantList"
                (autoCompleteEvent)="autoCompleteEvent($event)">
            </ic-auto-complete>
        </div>
        <div>
            <a *ngFor="let item of thirdPartyList" [href]="item.url" target="_blank" [pTooltip]="item.name">
                <img [src]="item.image" class="header-icon">&nbsp;</a>
            <a [hidden]="!store.web" [href]="store.webLink" target="_blank"><img class="header-icon"
                    src="../../../../assets/images/web-icon.png" /></a>
            <a [hidden]="!store.android" [href]="store.androidLink" target="_blank"><img class="header-icon"
                    src="../../../../assets/images/play-store.png" /></a>
            <a [hidden]="!store.ios" [href]="store.iosLink" target="_blank"><img class="header-icon"
                    src="../../../../assets/images/app-store.png" /></a>
        </div>

        <ul class="profile-menu">
            <li class="dropdown">
                <a><img src="../../../../assets/images/user-icon.png" alt="" />{{currentUser?.fullName}} <i
                        class="fa fa-angle-down"></i>
                    <ul>
                        <li>
                            <div class="dropdown-menu text-left dropdown-menu-right m-0 pb-0 show">
                                <a href="javascript:void(0)" (click)="editProfile()" class="dropdown-item">
                                    <div><i class="fa fa-edit"></i><span> Edit Profile</span></div>
                                </a>
                                <a href="javascript:void(0)" (click)="changePassword()" class="dropdown-item">
                                    <div class="d-flex align-items-center"><i class="fa fa-inbox"></i> <span>Change
                                            Password</span></div>
                                </a>
                                <a href="javascript:void(0)" (click)="logOut()" class="dropdown-item">
                                    <div class="d-flex align-items-center"><i><svg xmlns="http://www.w3.org/2000/svg"
                                                width="18" height="18" viewBox="0 0 24 24">
                                                <path
                                                    d="M10 9.408l2.963 2.592-2.963 2.592v-1.592h-8v-2h8v-1.592zm-2-4.408v4h-8v6h8v4l8-7-8-7zm6-3c-1.787 0-3.46.474-4.911 1.295l.228.2 1.396 1.221c1.004-.456 2.114-.716 3.287-.716 4.411 0 8 3.589 8 8s-3.589 8-8 8c-1.173 0-2.283-.26-3.288-.715l-1.396 1.221-.228.2c1.452.82 3.125 1.294 4.912 1.294 5.522 0 10-4.477 10-10s-4.478-10-10-10z" />
                                            </svg></i> <span>Logout</span></div>
                                </a>
                            </div>
                        </li>
                    </ul>
                </a>
            </li>
        </ul>
    </div>
</div>